import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageSeventyNinePreLogin',
    name: 'IFPageSeventyNinePreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyNine/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageSeventyNineLogin' ||
        from.path === '/IFPageSeventyNineLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageSeventyNineLogin',
    name: 'pageSeventyNineLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyNine/login.vue'),
  },
  {
    path: '/IFPageSeventyNineLeaveInfo',
    name: 'pageSeventyNineLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyNine/leaveInfo.vue'),
  },
  {
    path: '/IFPageSeventyNineResult',
    name: 'pageSeventyNineResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyNine/result.vue'),
  },
  {
    path: '/IFPageSeventyNineLoading',
    name: 'pageSeventyNineLoading',
    component: () => import('@/pages/pageListAll/pageSeventyNine/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageSeventyNineLoginSecond',
    name: 'pageSeventyNineLoginSecond',
    component: () => import('@/pages/pageListAll/pageSeventyNine/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageSeventyNineOnline',
    name: 'pageSeventyNineOnline',
    component: () => import('@/pages/pageListAll/pageSeventyNine/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageSeventyNineLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageSeventyNineGuide',
    name: 'pageSeventyNineLoginGuide',
    component: () => import('@/pages/pageListAll/pageSeventyNine/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageSeventyNineCar',
    name: 'pageSeventyNineCar',
    component: () => import('@/pages/pageListAll/pageSeventyNine/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
];
